<template>
  <div class="flex w-full px-[64px] py-[25px] h-[291px] lg:justify-between gap-[40px] xxl:max-w-[1312px] xxl:mx-auto">
    <div class="flex flex-row justify-between xlg:min-w-[323px] min-w-[280px]">
      <div class="flex flex-col gap-[16px]">
        <span class="label-small">Our games</span>
        <div
          class="heading-xsmall flex gap-[8px] cursor-pointer hover:text-[#EFEDF2]"
          @click="showOBK"
          @mouseenter="showOBK"
          @mouseleave="hideAllVisibility">
          <img
            src="@/assets/images/gamesnavbar/obk-icon-with-black.jpg "
            class="w-[24px] h-[24px] rounded-[4px] cursor-pointer" />
          <a :href="goToWebsite('/overview')" class="cursor-pointer" :class="{ 'text-[#EFEDF2]': OBKVisibility }"
            >Oh Baby Kart</a
          >
        </div>
        <div
          class="heading-xsmall flex gap-[8px] hover:text-[#EFEDF2]"
          @click="showShogun"
          @mouseenter="showShogun"
          @mouseleave="hideAllVisibility">
          <img
            src="@/assets/images/gamesnavbar/shogun-icon-white.png"
            class="w-[24px] h-[24px] rounded-[4px] cursor-pointer" />
          <a :href="goToWebsite('/shogun-curse')" class="cursor-pointer" :class="{ 'text-[#EFEDF2]': ShogunVisibility }"
            >Shogun Curse</a
          >
        </div>
        <div
          class="heading-xsmall flex gap-[8px] hover:text-[#EFEDF2]"
          @click="showBBB"
          @mouseenter="showBBB"
          @mouseleave="hideAllVisibility">
          <img
            src="@/assets/images/gamesnavbar/bbb-icon-white.png"
            class="w-[24px] h-[24px] rounded-[4px] cursor-pointer" />
          <a :href="goToWebsite('/bam-bam-boom')" class="cursor-pointer" :class="{ 'text-[#EFEDF2]': BBBVisibility }"
            >Bam Bam Boom</a
          >
        </div>
        <div
          class="heading-xsmall flex gap-[8px] hover:text-[#EFEDF2]"
          @click="showPawker"
          @mouseenter="showPawker"
          @mouseleave="hideAllVisibility">
          <img
            src="@/assets/images/gamesnavbar/pawker-icon.png"
            class="w-[24px] h-[24px] rounded-[4px] cursor-pointer" />
          <a :href="goToWebsite('/pawker')" class="cursor-pointer" :class="{ 'text-[#EFEDF2]': pawkerVisibility }"
            >Pawker</a
          >
        </div>
      </div>
      <div class="flex flex-col gap-[16px]" @mouseenter="showInsideOBK" @mouseleave="hideAllVisibility">
        <span class="label-small">Inside OBK</span>
        <a :href="goToWebsite('/overview')" class="body-medium hover:text-[#EFEDF2]">How to play</a>
        <a :href="goToWebsite('/twitch-drops')" class="body-medium hover:text-[#EFEDF2]">Twitch Drops</a>
        <a target="_blank" href="https://ohbabykart.wiki.gg/wiki/Characters" class="body-medium hover:text-[#EFEDF2]">Heroes</a>
        <a :href="goToWebsite('/stages')" class="body-medium hover:text-[#EFEDF2]">Stages</a>
      </div>
    </div>
    <transition name="fade" mode="out-in">
      <img
        v-if="(OBKVisibility || insideOBK) && !ShogunVisibility && !BBBVisibility && !pawkerVisibility"
        key="obk"
        src="@/assets/images/gamesnavbar/obk-kart-race.jpg"
        class="max-h-[241px] w-full object-cover rounded-[8px]" />
      <img
        v-else-if="!OBKVisibility && ShogunVisibility && !BBBVisibility && !insideOBK && !pawkerVisibility"
        key="shogun"
        src="@/assets/images/gamesnavbar/shogun-bg.jpg"
        class="max-h-[241px] w-full object-cover rounded-[8px]" />
      <img
        v-else-if="!OBKVisibility && !ShogunVisibility && BBBVisibility && !insideOBK && !pawkerVisibility"
        key="bbb"
        src="@/assets/images/gamesnavbar/bbb-bg.jpg"
        class="max-h-[241px] w-full object-cover rounded-[8px]" />
      <img
        v-else-if="!OBKVisibility && !ShogunVisibility && !BBBVisibility && !insideOBK && pawkerVisibility"
        key="pawker"
        src="@/assets/images/gamesnavbar/pawker_view.png"
        class="max-h-[241px] w-full object-cover rounded-[8px]" />
      <div v-else key="default" class="flex gap-[24px] w-full">
        <img src="@/assets/images/gamesnavbar/obk-kart-fire.jpg" class="w-1/4 h-[241px] object-cover rounded-[12px]" />
        <img
          src="@/assets/images/gamesnavbar/shogun-white-title.png"
          class="w-1/4 h-[241px] object-cover rounded-[12px]" />
        <img src="@/assets/images/gamesnavbar/bbb-characters.png" class="w-1/4 h-[241px] object-cover rounded-[12px]" />
        <img src="@/assets/images/gamesnavbar/pawker.png" class="w-1/4 h-[241px] object-cover rounded-[12px]" />
      </div>
    </transition>
  </div>
</template>
<script>
import envConfig from '../config';

export default {
  data() {
    return {
      OBKVisibility: false,
      ShogunVisibility: false,
      BBBVisibility: false,
      insideOBK: false,
      pawkerVisibility: false,
    };
  },
  methods: {
    showOBK() {
      this.OBKVisibility = true;
      this.ShogunVisibility = false;
      this.BBBVisibility = false;
      this.insideOBK = false;
      this.pawkerVisibility = false;
    },
    showShogun() {
      this.OBKVisibility = false;
      this.ShogunVisibility = true;
      this.BBBVisibility = false;
      this.insideOBK = false;
      this.pawkerVisibility = false;
    },
    showBBB() {
      this.OBKVisibility = false;
      this.ShogunVisibility = false;
      this.BBBVisibility = true;
      this.insideOBK = false;
      this.pawkerVisibility = false;
    },
    hideAllVisibility() {
      this.OBKVisibility = false;
      this.ShogunVisibility = false;
      this.BBBVisibility = false;
      this.insideOBK = false;
      this.pawkerVisibility = false;
    },
    showInsideOBK() {
      this.insideOBK = true;
      this.OBKVisibility = false;
      this.ShogunVisibility = false;
      this.BBBVisibility = false;
      this.pawkerVisibility = false;
    },
    showPawker() {
      this.pawkerVisibility = true;
      this.OBKVisibility = false;
      this.ShogunVisibility = false;
      this.BBBVisibility = false;
      this.insideOBK = false;
    },
    goToWebsite(relPath) {
      if (relPath) {
        return envConfig.websiteUrl + relPath;
      } else {
        return envConfig.websiteUrl;
      }
    },
  },
};
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}
</style>
